import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        toggleGroup: ({ disabled }: { disabled: boolean }) => {
            return {
                width: 'fit-content',
                background: disabled ? colors.color32 : colors.color1,
                padding: '4px',
                borderRadius: '40px',
                '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
                '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                    borderRadius: '40px !important',
                    borderColor: 'transparent',
                },
            }
        },
        toggle: {
            color: colors.color5,
            padding: '0px 10px',
            borderRadius: '40px',
            '&.Mui-selected': {
                '&:hover': {
                    background: colors.color5,
                    color: colors.color20
                },
                background: colors.color5,
                color: colors.color20,
                '&.Mui-disabled': {
                    background: colors.color5,
                    color: colors.color22,
                }
            }
        }
    }
}

export { useStyles }
